import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import React from "react";

function ConfirmationDialog({
    title,
    content,
    cancelButtonText,
    confirmButtonText,
    cancelButtonClass,
    confirmButtonClass,
    cancelButtonDisabled,
    confirmButtonDisabled,
    cancelButtonRender,
    confirmButtonRender,
    onConfirm,
    onCancel,
    onToggle
}) {
    return (
        <Dialog
            width={"30%"}
            title={title}
            onClose={onToggle}
        >
            <form>
                <div className="d-flex my-3 align-items-center save-content">
                    <i className="fas fa-exclamation-triangle text-warning display-7 me-3"></i>
                    <div>{content}</div>
                </div>
                <DialogActionsBar layout="end">
                    {
                        cancelButtonRender ?
                            cancelButtonRender() :
                            <button
                                type="button"
                                className={cancelButtonClass}
                                onClick={onCancel}
                                disabled={cancelButtonDisabled}
                            >
                                {cancelButtonText}
                            </button>
                    }
                    {
                        confirmButtonRender ?
                            confirmButtonRender() :
                            <button
                                type="button"
                                autoFocus={true}
                                className={confirmButtonClass}
                                onClick={onConfirm}
                                disabled={confirmButtonDisabled}
                            >
                                {confirmButtonText}
                            </button>
                    }
                </DialogActionsBar>
            </form>
        </Dialog>
    )
}

ConfirmationDialog.defaultProps = {
    cancelButtonClass: "btn btn-secondary",
    confirmButtonClass: "btn btn-primary",
    cancelButtonText: "Cancel",
    confirmButtonText: "Confirm"
}

export default ConfirmationDialog;